import { Uuid } from '@ftr/contracts/type/shared'

export class FetchVocabularyTermsAction {
  static readonly type = '[Vocabulary] Fetch Vocabulary Terms'
  constructor(
    public courtSystemId: Uuid,
    public bypassCache?: boolean,
  ) {}
}
